import React from 'react';
import { Box, ChevronRightIcon, ExpressSetupDoneIcon, Inscription } from '@common-fe/common-fe';

interface Props {
  title: string;
  isCompleted?: boolean;
  actionNode?: React.ReactNode;
  infoNode?: React.ReactNode;
  onClick?: () => void;
}

export const ExpressSetupSummaryItem: React.FC<Props> = ({
  title,
  isCompleted,
  actionNode,
  onClick,
  infoNode,
}) => {
  return (
    <Box
      data-testid="ExpressSetupSummaryItem"
      width="100%"
      height={{ min: '72px' }}
      justify="center"
      pad={{ horizontal: 'spacing24', vertical: 'spacing16' }}
      round="container1Round"
      background={{ color: isCompleted ? 'successContainer' : 'border1' }}
      style={{ cursor: 'default' }}
    >
      <Box
        direction="row"
        align="center"
        justify="between"
        margin={{ bottom: infoNode ? 'spacing12' : undefined }}
      >
        <Box direction="row" align="center" gap="spacing12">
          {
            isCompleted
              ? (
                <ExpressSetupDoneIcon
                  size="32px"
                  color='success'
                  data-testid="ExpressSetupSummaryItem-ExpressSetupDoneIcon"
                />
              )
              : (
                <Box
                  round="50%"
                  background="background3"
                  style={{ opacity: 0.1 }}
                  height="32px"
                  width="32px"
                  data-testid="ExpressSetupSummaryItem-EmptyIcon"
                />
              )
          }
          <Inscription
            size="16px"
            color="textBody"
            weight={700}
            lineHeight="22px"
            data-testid="ExpressSetupSummaryItem-Title"
          >
            {title}
          </Inscription>
        </Box>

        <Box
          direction="row"
          align="center"
          gap="spacing8" 
          style={{ cursor: 'pointer' }}
          onClick={onClick}
          data-testid="ExpressSetupSummaryItem-Action"
        >
          {actionNode}
          {isCompleted && (
            <Box>
              <ChevronRightIcon />
            </Box>
          )}
        </Box>
      </Box>
      {infoNode}
    </Box>
  );
};
